export default __webpack_public_path__ + "static/bncff-web-site-4-a26f08e6222ea598059a04bc5ff67379.jpg";